/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IAgentBonus } from '../agent_bonus/AgentBonus';
import type { IPricePresenter } from '../price_presenter/PricePresenter';
import type { IUtilitiesTerms } from '../utilities_terms/UtilitiesTerms';

export interface IBargainTermsPresenter {
  /** Бонус агентам **/
  agentBonus?: TBargainTermsPresenter_AgentBonus;
  /** Комиссия от другого агента, %% **/
  agentFee?: TBargainTermsPresenter_AgentFee;
  /** Возможен торг **/
  bargainAllowed?: TBargainTermsPresenter_BargainAllowed;
  /** Условия торга **/
  bargainConditions?: TBargainTermsPresenter_BargainConditions;
  /** Цена с учетом торга **/
  bargainPrice?: TBargainTermsPresenter_BargainPrice;
  /** Цена с учетом торга **/
  bargainPricePrices?: TBargainTermsPresenter_BargainPricePrices;
  /** Комиссия от прямого клиента, %% **/
  clientFee?: TBargainTermsPresenter_ClientFee;
  /** Тип договора **/
  contractType?: TBargainTermsPresenter_ContractType;
  /** Валюта **/
  currency?: TBargainTermsPresenter_Currency;
  /** Залог собственнику **/
  deposit?: TBargainTermsPresenter_Deposit;
  /** Залог собственнику **/
  depositPrices?: TBargainTermsPresenter_DepositPrices;
  /** Арендные каникулы **/
  hasGracePeriod?: TBargainTermsPresenter_HasGracePeriod;
  /** Включено в ставку **/
  includedOptions?: TBargainTermsPresenter_IncludedOptions;
  /** Срок аренды **/
  leaseTermType?: TBargainTermsPresenter_LeaseTermType;
  /** Тип аренды **/
  leaseType?: TBargainTermsPresenter_LeaseType;
  /** Минимальный срок аренды, мес **/
  minLeaseTerm?: TBargainTermsPresenter_MinLeaseTerm;
  /** Ипотека **/
  mortgageAllowed?: TBargainTermsPresenter_MortgageAllowed;
  /** Период оплаты **/
  paymentPeriod?: TBargainTermsPresenter_PaymentPeriod;
  /** Предоплата **/
  prepayMonths?: TBargainTermsPresenter_PrepayMonths;
  /** Цена **/
  price?: TBargainTermsPresenter_Price;
  /** Цена в евро **/
  priceEur?: TBargainTermsPresenter_PriceEur;
  /** Цена за рабочее место **/
  priceForWorkplace?: TBargainTermsPresenter_PriceForWorkplace;
  /** Цена в рублях **/
  priceRur?: TBargainTermsPresenter_PriceRur;
  /** Тип цены **/
  priceType?: TBargainTermsPresenter_PriceType;
  /** Цена в долларах **/
  priceUsd?: TBargainTermsPresenter_PriceUsd;
  /** Тип продажи **/
  saleType?: TBargainTermsPresenter_SaleType;
  /** Обеспечительный платеж **/
  securityDeposit?: TBargainTermsPresenter_SecurityDeposit;
  /** Обеспечительный платеж **/
  securityDepositPrices?: TBargainTermsPresenter_SecurityDepositPrices;
  /** Состав съемщиков **/
  tenantsType?: TBargainTermsPresenter_TenantsType;
  /** Коммунальные услуги **/
  utilitiesTerms?: TBargainTermsPresenter_UtilitiesTerms;
  /** Коммунальные услуги **/
  utilitiesTermsPrices?: TBargainTermsPresenter_UtilitiesTermsPrices;
  /** НДС включен (deprecated) **/
  vatIncluded?: TBargainTermsPresenter_VatIncluded;
  /** Сумма налога **/
  vatPrice?: TBargainTermsPresenter_VatPrice;
  /** Сумма налога **/
  vatPrices?: TBargainTermsPresenter_VatPrices;
  /** НДС **/
  vatType?: TBargainTermsPresenter_VatType;
}

export type TBargainTermsPresenter_AgentBonus = null | IAgentBonus;

export type TBargainTermsPresenter_AgentFee = null | number;

export type TBargainTermsPresenter_BargainAllowed = null | boolean;

export type TBargainTermsPresenter_BargainConditions = null | string;

export type TBargainTermsPresenter_BargainPrice = null | number;

export type TBargainTermsPresenter_BargainPricePrices = null | IPricePresenter;

export type TBargainTermsPresenter_ClientFee = null | number;

export type TBargainTermsPresenter_ContractType = null | EContractType;

export enum EContractType {
  /** Переуступка прав аренды **/
  LeaseAssignment = 'leaseAssignment',
  /** Продажа **/
  Sale = 'sale',
}
export type TBargainTermsPresenter_Currency = null | ECurrency;

export enum ECurrency {
  /** € **/
  Eur = 'eur',
  /** руб. **/
  Rur = 'rur',
  /** $ **/
  Usd = 'usd',
}
export type TBargainTermsPresenter_Deposit = null | number;

export type TBargainTermsPresenter_DepositPrices = null | IPricePresenter;

export type TBargainTermsPresenter_HasGracePeriod = null | boolean;

export type TBargainTermsPresenter_IncludedOptions = null | EIncludedOptions[];

export enum EIncludedOptions {
  /** Операционные расходы **/
  OperationalCosts = 'operationalCosts',
  /** Коммунальные платежи **/
  UtilityCharges = 'utilityCharges',
}
export type TBargainTermsPresenter_LeaseTermType = null | ELeaseTermType;

export enum ELeaseTermType {
  /** На несколько месяцев **/
  FewMonths = 'fewMonths',
  /** Длительный **/
  LongTerm = 'longTerm',
}
export type TBargainTermsPresenter_LeaseType = null | ELeaseType;

export enum ELeaseType {
  /** Прямая аренда **/
  Direct = 'direct',
  /** Договор совместной деятельности **/
  JointVenture = 'jointVenture',
  /** Субаренда **/
  Sublease = 'sublease',
}
export type TBargainTermsPresenter_MinLeaseTerm = null | number;

export type TBargainTermsPresenter_MortgageAllowed = null | boolean;

export type TBargainTermsPresenter_PaymentPeriod = null | EPaymentPeriod;

export enum EPaymentPeriod {
  /** За год **/
  Annual = 'annual',
  /** За месяц **/
  Monthly = 'monthly',
}
export type TBargainTermsPresenter_PrepayMonths = null | number;

export type TBargainTermsPresenter_Price = null | number;

export type TBargainTermsPresenter_PriceEur = null | number;

export type TBargainTermsPresenter_PriceForWorkplace = null | number;

export type TBargainTermsPresenter_PriceRur = null | number;

export type TBargainTermsPresenter_PriceType = null | EPriceType;

export enum EPriceType {
  /** Цена за все **/
  All = 'all',
  /** Цена за гектар **/
  Hectare = 'hectare',
  /** Цена за сотку **/
  Sotka = 'sotka',
  /** Цена за квадратный метр **/
  SquareMeter = 'squareMeter',
}
export type TBargainTermsPresenter_PriceUsd = null | number;

export type TBargainTermsPresenter_SaleType = null | ESaleType;

export enum ESaleType {
  /** Альтернатива **/
  Alternative = 'alternative',
  /** Договор уступки права требования **/
  Dupt = 'dupt',
  /** Договор ЖСК **/
  Dzhsk = 'dzhsk',
  /** Свободная продажа **/
  Free = 'free',
  /** 214-ФЗ **/
  Fz214 = 'fz214',
  /** Договор инвестирования **/
  Investment = 'investment',
  /** Предварительный договор купли-продажи **/
  Pdkp = 'pdkp',
}
export type TBargainTermsPresenter_SecurityDeposit = null | number;

export type TBargainTermsPresenter_SecurityDepositPrices = null | IPricePresenter;

export type TBargainTermsPresenter_TenantsType = null | ETenantsType;

export enum ETenantsType {
  /** Любой **/
  Any = 'any',
  /** Семья **/
  Family = 'family',
  /** Женщина **/
  Female = 'female',
  /** Мужчина **/
  Male = 'male',
}
export type TBargainTermsPresenter_UtilitiesTerms = null | IUtilitiesTerms;

export type TBargainTermsPresenter_UtilitiesTermsPrices = null | IPricePresenter;

export type TBargainTermsPresenter_VatIncluded = null | boolean;

export type TBargainTermsPresenter_VatPrice = null | number;

export type TBargainTermsPresenter_VatPrices = null | IPricePresenter;

export type TBargainTermsPresenter_VatType = null | EVatType;

export enum EVatType {
  /** НДС включен **/
  Included = 'included',
  /** НДС не включен **/
  NotIncluded = 'notIncluded',
  /** УСН (упрощенная система налогообложения) **/
  Usn = 'usn',
}
